import { TextField } from '@mui/material'
import DialogContentText from '@mui/material/DialogContentText'
import { useFormik } from 'formik'
import produce from 'immer'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import * as yup from 'yup'

import ResponsiveDialog from '../../../../components/ResponsiveDialog'
import { selectUser } from '../slice'

function SetPasswordDialog({ open, userId, onSubmit, onClose, ...props }) {
  const user = useSelector(selectUser(userId))

  const [initialValues, setInitialValues] = useState({})

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: yup.object({
      new_password: yup
        .string('Enter new password')
        .required('New password is required')
    }),
    onSubmit: (values) => {
      handleSubmit(values)
    }
  })

  const handleSubmit = (values) => {
    onSubmit(
      produce(values, (draft) => {
        if (userId != null) {
          draft.id = userId
        }
        return draft
      })
    )
    formik.resetForm()
    onClose()
  }

  const handleClose = () => {
    formik.resetForm()
    onClose()
  }

  useEffect(
    () =>
      setInitialValues({
        new_password: ''
      }),
    [user]
  )

  return (
    <ResponsiveDialog
      title="Set Password"
      open={open}
      onClose={handleClose}
      onSubmit={() => {
        formik.submitForm()
      }}
      {...props}
    >
      <DialogContentText>
        To set the password for this user, please enter all required details
        here.
      </DialogContentText>
      <TextField
        autoFocus
        fullWidth
        name="new_password"
        label="New Password"
        type="password"
        variant="standard"
        value={formik.values.new_password}
        onChange={formik.handleChange}
        error={
          formik.touched.new_password && Boolean(formik.errors.new_password)
        }
        helperText={formik.touched.new_password && formik.errors.new_password}
      />
    </ResponsiveDialog>
  )
}

SetPasswordDialog.propTypes = {
  open: PropTypes.bool,
  userId: PropTypes.number,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
}

export default SetPasswordDialog
